import { useState } from "react"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorTriggerProps } from "@/v2-backoffice-client/components/selector"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserCustomerUpdateSelectorList from "@/v2-backoffice-client/user/customer/update/UserCustomerUpdateSelectorList"

export type UserCustomerUpdateSelectorProps = SelectorTriggerProps & {
  user: UserFragment
}

/**
 * Toolbar button that opens the owner picker for one user: the customer
 * whose licenses and seats apply to them. The team toolbar's Customer
 * button is the same control for a team.
 */
function UserCustomerUpdateSelector(props: UserCustomerUpdateSelectorProps) {
  const { user, ...triggerProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Selector onOpenChange={setIsOpen}>
      <Selector.Trigger iconSrc="users-alt" {...triggerProps}>
        {triggerProps.children ?? "Customer"}
      </Selector.Trigger>

      <Selector.Content>
        <UserCustomerUpdateSelectorList user={user} open={isOpen} />
      </Selector.Content>
    </Selector>
  )
}

export default UserCustomerUpdateSelector
